import { render } from "./Results.vue?vue&type=template&id=5cdf9bac"
import script from "./Results.vue?vue&type=script&lang=ts"
export * from "./Results.vue?vue&type=script&lang=ts"

import "./Results.vue?vue&type=style&index=0&id=5cdf9bac&lang=scss"
script.render = render

export default script